import { GetConsentStatusResponseBodyPurposesItemDTO } from '@ketch-com/figurehead'
import { ConsentSource } from '@ketch-sdk/ketch-types'
import { Box, styled } from '@mui/material'
import { SummaryCard, SummaryCardProps } from 'pages/insights/auditLog/components/SummaryCard'
import { defaultOptOutLegalBases } from 'pages/insights/auditLog/components/consentsTab/hooks/useConsentTabAggregateData'
import { SourceLabels } from 'pages/insights/auditLog/constants'
import React, { useMemo } from 'react'
import { formatDateTimeFromUnix } from 'utils/helpers/dateTime'

type ListItemCardsProps = {
  purpose: GetConsentStatusResponseBodyPurposesItemDTO
}

const CardsBox = styled(Box)({
  display: 'flex',
  gap: 16,
  marginBottom: 16,
})

export const ListItemCards: React.FC<ListItemCardsProps> = ({ purpose }) => {
  const cardData: SummaryCardProps[] = useMemo<SummaryCardProps[]>(
    () => [
      {
        fieldName: 'Last Updated',
        fieldValue: formatDateTimeFromUnix(purpose.collectedAt),
        icon: 'OCalendar',
      },
      {
        fieldName: 'Jurisdiction',
        fieldValue: purpose.jurisdictionName,
        icon: 'FScales',
      },
      {
        fieldName: 'Property',
        fieldValue: purpose.propertyName,
        icon: 'FGlobe',
      },
      {
        fieldName: 'Interaction Method',
        fieldValue: SourceLabels[purpose.context?.source as ConsentSource] || purpose.context?.source || 'Unknown',
        icon: 'OPointer',
      },
      {
        fieldName: 'GPC Signal',
        fieldValue: purpose.context?.isGpcEnabled ? 'Yes' : 'No',
        icon: 'OBroadcast',
      },
      {
        fieldName: 'Default State',
        fieldValue: defaultOptOutLegalBases.includes(purpose.legalBasis || '') ? 'Opted Out' : 'Opted In',
        icon: 'OSettings',
      },
    ],
    [purpose],
  )

  return (
    <CardsBox>
      {cardData.map(card => (
        <SummaryCard key={card.fieldName} {...card} />
      ))}
    </CardsBox>
  )
}
